import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import { isTokenExpired } from '../../../../utils/tokenUtil';
import { refreshAuthTokenRequest } from '../../../../store/ducks/auth/actions';
import { RENEW_TOKEN_INTERVAL_MILLISECONDS } from '../../../../store/ducks/auth/types';

const StaticTokenRenewal: React.FC = () => {
  const dispatch = useDispatch();
  const { azureDateTimeExpiration } = useSelector(
    (state: ApplicationState) => state.auth
  );

  useEffect(() => {
    if (azureDateTimeExpiration && isTokenExpired(azureDateTimeExpiration)) {
      dispatch(refreshAuthTokenRequest());
    }

    const intervalId = setInterval(() => {
      dispatch(refreshAuthTokenRequest());
    }, RENEW_TOKEN_INTERVAL_MILLISECONDS);

    return () => clearInterval(intervalId);
  }, [dispatch, azureDateTimeExpiration]);

  return null;
};

export default StaticTokenRenewal;
